const BaseStatus = {
    REGISTERED: 'REGISTERED',
    UNREGISTERED: 'UNREGISTERED',
    PENDING: 'PENDING',
    SUSPENDED: 'SUSPENDED',
    PAUSED: 'PAUSED',
    UNKNOWN: 'UNKNOWN'
}

const Mode = {
    VIEW: 'view',
    EDIT: 'edit'
}

export { BaseStatus, Mode };